export default __webpack_public_path__ + "static/media/icon_google_tagmanager.618aa5ce.svg";